module.exports = "           \n<app-brief-description (notifyjobdesc)='onNotify($event)' *ngFor=\"let description of job.controls; let i=index\" [index]=\"i\" [description]=\"description\" (removed)=\"job.removeAt($event)\">\n</app-brief-description>\n<h6><span *ngIf=\"exceed\" class=\"exceed_warning\">Careful, your resume might exceed a page!</span></h6>\n<button type=\"button\" class=\"btn btn-link\" (click)=\"addItemy()\">Add more bullets</button>"


//////////////////
// WEBPACK FOOTER
// ./src/app/main/content/jobs/job-description/job-detail/job-detail.component.html
// module id = ./src/app/main/content/jobs/job-description/job-detail/job-detail.component.html
// module chunks = main